module.exports = __webpack_public_path__ + "img/40_69_007_900.cbaa6cfc.jpg";